import { render, staticRenderFns } from "./SubmissionConsentButton.vue?vue&type=template&id=8bf528a6&scoped=true"
import script from "./SubmissionConsentButton.vue?vue&type=script&lang=js"
export * from "./SubmissionConsentButton.vue?vue&type=script&lang=js"
import style0 from "./SubmissionConsentButton.vue?vue&type=style&index=0&id=8bf528a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf528a6",
  null
  
)

export default component.exports